<template>
  <div id="video" class="single embed">
    <video-player></video-player>
  </div>
</template>

<script>
import VideoPlayer from '@/components/VideoPlayer'

export default {

  name: 'Video',

  components: {
    VideoPlayer
  },

  data () {
    return {

    }
  },

  computed: {
  },

  methods: {
    isVisible: function () {
    }
  }
}
</script>

<style lang="css">
#notice {
  display: none;
}

.embed #video-player {
  overflow: hidden !important;
}

.embed .video-details {
  display: none;
}

.embed .back {
  display: none;
}

#video.embed .plyr {
  max-width: inherit !important;
  margin: inherit !important;
}

#video.embed #video-player {
  background-color: #000;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  left: 0;
  width: 100vw;
}

.embed .video-title {
  display: none;
}

.embed .plyr audio, .embed .plyr video {
  height:100vh;
}

.embed .plyr__video-wrapper {
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/VideoEmbed.vue